import { ArrowForward } from '@lichtblick/icons';
import { TextVariants } from '@lichtblick/theme';

import { Content } from './InteractiveCard.styles';

import { Card } from '../Card';
import { Text } from '../Text';

type InteractiveCardProps = {
  isBorderless?: boolean;
  onClick: () => void;
  subtitle?: string;
  title: string;
};

export const InteractiveCard = ({ isBorderless = true, onClick, subtitle, title }: InteractiveCardProps) => (
  <Card isBorderless={isBorderless} width={'16rem'}>
    <Content onClick={onClick}>
      <div>
        <Text $variant={TextVariants.body.l}>{title}</Text>
        {subtitle && <Text $variant={TextVariants.body.m}>{subtitle}</Text>}
      </div>
      <ArrowForward />
    </Content>
  </Card>
);
